// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__UF1fl","content":"LayoutSettings_content__1GvMW"};